/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import {
  ExpandMore,
  ExpandLess,
  ViewList,
  List,
  NoteAddRounded,
} from "@material-ui/icons";

import {
  sNewNote,
  sExpandAll,
  sFoldupAll,
  sEnlargeNZ,
  sReduceNZ,
} from "assets/jss/views/ResStrings";
import {
  idLargeNZ,
  idSmallNZ,
  idNewNtSmall,
  idExpNotes,
  idFoldNotes,
} from "assets/jss/views/ElementIDs";

export const noteCtrlButtons = (onNoteCtrl: any, ctrlIcon: any) => [
  {
    icon: <ExpandLess classes={{ root: ctrlIcon }} />,
    name: sEnlargeNZ,
    action: () => onNoteCtrl({ action: "enlarge" }),
    id: idLargeNZ,
  },
  {
    icon: <ExpandMore classes={{ root: ctrlIcon }} />,
    name: sReduceNZ,
    action: () => onNoteCtrl({ action: "reduce" }),
    id: idSmallNZ,
  },
  {
    icon: <NoteAddRounded classes={{ root: ctrlIcon }} />,
    name: sNewNote,
    action: () => onNoteCtrl({ action: "add" }),
    id: idNewNtSmall,
  },
  {
    icon: <ViewList classes={{ root: ctrlIcon }} />,
    name: sExpandAll,
    action: () => onNoteCtrl({ action: "unfold" }),
    id: idExpNotes,
  },
  {
    icon: <List classes={{ root: ctrlIcon }} />,
    name: sFoldupAll,
    action: () => onNoteCtrl({ action: "fold" }),
    id: idFoldNotes,
  },
];
